import { Injectable } from '@angular/core';
import { EmployeeStatusModel } from './model/employee-status.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmployeeStatusService {

  constructor(private http: HttpClient) { }

  getList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/hr/employee-statuses/list', requestData);
  }

  getById(id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/employee-status/get/' + id, '');
  }

  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(environment.baseUrl + '/employee-status/exportdatacsv', requestData, { headers, responseType: 'blob' });
  }

  update(info: EmployeeStatusModel): Observable<any> {
    if (info.hasOwnProperty("id") && info.id !== 0) {
      return this.http.post(environment.baseUrl + '/employee-status/update', info);
    } else {
      return this.http.post(environment.baseUrl + '/employee-status/add', info);
    }
  }

  delete(info: EmployeeStatusModel): Observable<any> {
    return this.http.post(environment.baseUrl + '/employee-status/delete/' + info.id, info);
  }
}
